import { API_URL } from "@/env"

export type ValidatorResponse = {
  votePubkey: string
  commission: string
  totalStakeLamports: string
  apyPercent: string
  epoch: string
}

export const fetchValidatorInfo = async (): Promise<ValidatorResponse> => {
  const res = await fetch(`${API_URL}/staking/validator`)
  if (!res.ok) throw new Error(`Validator API error: ${res.status}`)
  return res.json()
}

export type WalletPointsResponse = {
  totalPoints: number
}

export const fetchWalletPoints = async (walletAddress: string): Promise<WalletPointsResponse> => {
  const res = await fetch(`${API_URL}/user/wallet/points?walletAddress=${encodeURIComponent(walletAddress)}`)
  if (!res.ok) throw new Error(`Wallet points API error: ${res.status}`)
  return res.json()
}

export type StakingRewardsResponse = {
  minStakeSol: string
  base: string
  rate: string
}

export const fetchStakingRewardsConfig = async (): Promise<StakingRewardsResponse> => {
  const res = await fetch(`${API_URL}/configuration/staking-rewards`)
  if (!res.ok) throw new Error(`Staking rewards API error: ${res.status}`)
  return res.json()
}
